import React, { MouseEvent, PureComponent } from 'react';
import { HamburgerContainer } from '../../components/Hamburger';

interface HamburgerProps {
  active: boolean;
  onClick: (e: MouseEvent<HTMLElement>) => void;
}

class Hamburger extends PureComponent<HamburgerProps> {
  public render() {
    const { onClick, active } = this.props;

    return (
      <HamburgerContainer active={active} onClick={onClick}>
        <div>
          <span />
        </div>
      </HamburgerContainer>
    );
  }
}

export default Hamburger;
